// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/handle.ts"
);
import.meta.hot.lastModified = "1724922490000";
}
// REMIX HMR END

import { UIMatch, useMatches } from "@remix-run/react";
import { TourismItemForClient } from "~/types/apiTourism";

export const usePathHandle = () => {
    const matches = useMatches();
    const match = matches.find((it) => it.handle);

    if (match?.handle) {
        // @ts-expect-error asdf
        return match.handle?.page
    }

    return null

}



export const useLoaderDataByHandle = (handle: string) => {
    const matches = useMatches()
    // if (!handle) return null

    for (let i = 0; i < matches.length; i += 1) {
        const possibleMatch = matches[i]?.handle
        if (
            possibleMatch
            && typeof possibleMatch === "object"
            && 'page' in possibleMatch
            && possibleMatch?.page === handle
        ) {
            return matches[i].data
        }
    }

    return null

}


export const getMatchFromMatchesByPageHandle = (matches: UIMatch[]  , handle: string): UIMatch | null => {
    for (let i = 0; i < matches.length; i += 1) {
        if (matches[i].handle) {
            const candidate = matches[i].handle

            if (candidate && typeof candidate === 'object' && 'page' in candidate) {

                if (candidate.page === handle) {
                    return matches[i]
                }
            }
        }
    }
    return null
}


export const extractDataFromMatch = (match: UIMatch["data"] | null): TourismItemForClient | null => {

    if (!match) return null

    const possiblyData = match

    if (possiblyData && typeof possiblyData === 'object' && 'res' in possiblyData) {
        const res = possiblyData?.res
        if (res && typeof res === 'object' && 'data' in res) {
            if (Array.isArray(res?.data)) {
                const data = res?.data[0]
                if (data) return res?.data[0]
            }
        }
    }

    return null

}